var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-gray-200"},[_c('div',{staticClass:"container container-page mx-auto"},[_c('nav',{staticClass:"px-6"},[_c('ul',{staticClass:"flex overflow-x-auto"},[_c('NavBarRoutes',{attrs:{"routes":_vm.navRoutes}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }